import dayjs from 'dayjs';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  dateRangeAtom,
  periodEndDateAtom,
  periodStartDateAtom,
  periodTypeAtom,
  selectedDeviceStateAtom,
} from '../models/atoms/device_atoms';

export function useDeviceDataDateRange() {
  const selectedDevice = useRecoilValue(selectedDeviceStateAtom);
  const dateRange = useRecoilValue(dateRangeAtom);
  const setPeriodType = useSetRecoilState(periodTypeAtom);
  const [periodStartDate, setPeriodStartDate] =
    useRecoilState(periodStartDateAtom);
  const [periodEndDate, setPeriodEndDate] = useRecoilState(periodEndDateAtom);

  function changeStartDate(date: Date) {
    if (!selectedDevice) {
      return;
    }

    setPeriodStartDate(dayjs(date));
    setPeriodType('custom');
  }

  function changeEndDate(date: Date) {
    if (!selectedDevice) {
      return;
    }

    setPeriodEndDate(dayjs(date));
    setPeriodType('custom');
  }

  function shouldDisableStartDate(date: Date) {
    return (
      dayjs(date) < dateRange.start ||
      dayjs(date) > dateRange.end ||
      dayjs(date) > periodEndDate
    );
  }

  function shouldDisableEndDate(date: Date) {
    return (
      dayjs(date) < dateRange.start ||
      dayjs(date) > dateRange.end ||
      dayjs(date) < periodStartDate
    );
  }

  return {
    changeStartDate,
    changeEndDate,
    shouldDisableStartDate,
    shouldDisableEndDate,
  };
}
